import React, { useState } from "react";
import { assessmentHistory } from "../GrowthLoopSeed";

const GLAssessors = ({
  accessors,
  setAccessors,
  lang,
}) => {
  const [showSample, setShowSample] = useState(false);

  const updateField = (field, value) => {
    setAccessors((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="space-y-3">

      <h2 className="text-sm font-bold text-cyan-300">
        {lang === "hi"
          ? "Assessment Access"
          : "Assessment Access"}
      </h2>

      <input
        className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
        placeholder={
          lang === "hi"
            ? "Parent Think5Whys Code"
            : "Parent Think5Whys Code"
        }
        value={accessors.parentCode || ""}
        onChange={(e) =>
          updateField("parentCode", e.target.value)
        }
      />

      <input
        className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
        placeholder={
          lang === "hi"
            ? "Educator Codes (comma separated)"
            : "Educator Codes (comma separated)"
        }
        value={accessors.educatorCodes || ""}
        onChange={(e) =>
          updateField("educatorCodes", e.target.value)
        }
      />

      <input
        className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
        placeholder={
          lang === "hi"
            ? "Doctor Codes (comma separated)"
            : "Doctor Codes (comma separated)"
        }
        value={accessors.doctorCodes || ""}
        onChange={(e) =>
          updateField("doctorCodes", e.target.value)
        }
      />

      <input
        className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
        placeholder={
          lang === "hi"
            ? "External Expert Codes"
            : "External Expert Codes"
        }
        value={accessors.externalCodes || ""}
        onChange={(e) =>
          updateField("externalCodes", e.target.value)
        }
      />

      <button
        onClick={() => setShowSample((s) => !s)}
        className="w-full rounded-lg py-2 text-xs font-semibold bg-gray-800 border border-gray-700 text-cyan-300 hover:bg-gray-700"
      >
        {showSample
          ? (lang === "hi" ? "सैंपल डेटा छिपाएं" : "Hide Sample Data")
          : (lang === "hi" ? "सैंपल डेटा दिखाएं" : "Show Sample Data")}
      </button>

      {showSample && (
        <div className="bg-gray-900 border border-gray-800 rounded-xl p-3 space-y-3">
          <p className="text-xs text-yellow-300 font-semibold">
            {lang === "hi" ? "⚠ यह डेमो/नमूना डेटा है" : "⚠ This is demo/sample data"}
          </p>

          <div>
            <p className="text-xs text-gray-200 mb-1 uppercase tracking-wider">
              {lang === "hi" ? "अंकनकर्ता" : "Assessors"}
            </p>
            {assessmentHistory.accessors.map((a, i) => (
              <div key={i} className="flex justify-between text-xs text-gray-100 py-0.5">
                <span>{a.name}</span>
                <span className="text-gray-400">{a.category}</span>
              </div>
            ))}
          </div>

          <div>
            <p className="text-xs text-gray-200 mb-1 uppercase tracking-wider">
              {lang === "hi" ? "एक्सेस लॉग" : "Access Log"}
            </p>
            {assessmentHistory.accessLog.map((log) => (
              <div key={log.sn} className="text-xs text-gray-100 py-0.5 flex justify-between">
                <span>{log.name}</span>
                <span className="text-gray-400">{log.datetime}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="text-xs text-gray-500">
        {lang === "hi"
          ? "भविष्य में केवल अधिकृत उपयोगकर्ता ही Assessment देख एवं अपडेट कर सकेंगे।"
          : "Only authorized Think5Whys users will be allowed to access or update this assessment in future."}
      </div>

    </div>
  );
};

export default GLAssessors;